import React, { useEffect } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
    useLocation,
    useRouteMatch
} from "react-router-dom";

import Index from './pages/index/index';
import Menu from "./components/menu/Menu";
import Home from "./pages/home/Home";
import PostEdit from "./pages/postEdit/PostEdit";
import Profile from "./pages/profile/Profile";
import Busca from "./pages/busca/Busca";
import MyPosts from "./pages/myposts/MyPosts";
import NewPost from './pages/newPost/newPost';
// import IndexPreview from './pages/preview/indexPreview';
import Preview from "./pages/preview/Preview";
import PreviewInicio from "./pages/preview/previewInicio";
import PreviewPostId from "./pages/preview/post_id/previewPostId";
import PreviewSobreMim from './pages/preview/previewSobreMim';
import Categoria from "./pages/categorias/categorias";
// import EditorImage from './components/editorImage/editorImage';
import Prepagamento from './pages/prepagamento/Prepagamento';
import AdminClientes from './pages/admin/clientes';
import NovoTemplate from './pages/admin/novoTemplate';
import AllPostsUnblocked from './pages/unblockedPosts/UnblockedPosts';
import TemplateEdit from './pages/templateEdit/TemplateEdit';
import { isAuthenticated } from './services/auth';
import ColetaDados from './pages/loginPage/loginPage';
import PaymentSuccess from './pages/paymentSuccess/paymentSuccess';
import NotFound from './pages/notFound/notFound';
import { getURLByAlias } from './services/servicesGetURLByAlias';
import Tutorials from './pages/tutorials/Tutorials';
import ConfigPagesBlog from './pages/configPageBlog/configPageBlog';
const PrivateRoute = ({ component: Component, ...rest }) => {
    // console.log(rest);

    return (
        <Route
            {...rest}
            render={props => {
                // console.log(Component)
                return isAuthenticated() ? (
                    <Component {...props} />
                    // console.log(rest)
                ) : (
                    <Redirect to={{ pathname: "/", state: { from: props.location } }} />
                )
            }
            }
        />
    )
};



export default function App() {
    async function verifyAlias() {
        const alias = await getURLByAlias(window.location.pathname.split('/')[1]);
        if (alias.status === 200) {
            window.location.href = `https://social.medx.med.br/sites/${window.location.pathname.split('/')[1]}/index.html`
        } else {
            window.location.pathname = '/'
        }
    }
    useEffect(() => {
        const url = window.location.pathname.split('/')[1];
        if (url !== '' && url !== 'app' && url !== 'coleta' && url !== 'redirect' && url !== 'payment-success')
            verifyAlias()
    }, [])

    return (
        <Router>
            <Switch>
                <Route path="/app">
                    <Menu />
                    <MainRoute />
                </Route>
                <Route path='/' exact component={Index} />

                <Route path='/coleta' exact component={ColetaDados} />
                <Route path='/redirect' exact component={Index} />
                <Route path='/payment-success' exact component={PaymentSuccess} />
                <Route path="/404" component={NotFound} />
                <Route path='/:nome' ></Route>
                <Redirect from='*' to='/404' />
            </Switch>
        </Router>
    );
};

export function MainRoute() {
    const location = useLocation();
    const match = useRouteMatch();
    return (

        <Switch location={location} >
            <PrivateRoute path={`${match.path}/home`} component={Home} />
            <PrivateRoute path={`${match.path}/postedit/`} component={PostEdit} />
            <PrivateRoute path={`${match.path}/profile`} component={Profile} />
            <PrivateRoute path={`${match.path}/busca`} component={Busca} />
            <PrivateRoute path={`${match.path}/myposts`} exact component={MyPosts} />
            <PrivateRoute path={`${match.path}/newPost`} component={NewPost} />
            <PrivateRoute path={`${match.path}/categoria`} component={Categoria} />
            <PrivateRoute path={`${match.path}/preview`} exact component={Preview} />
            <PrivateRoute path={`${match.path}/preview/inicio`} exact component={PreviewInicio} />
            <PrivateRoute path={`${match.path}/preview/post_id/`} component={PreviewPostId} />
            <PrivateRoute path={`${match.path}/preview/sobremim`} component={PreviewSobreMim} />
            <PrivateRoute path={`${match.path}/prepagamento`} component={Prepagamento} />
            <PrivateRoute path={`${match.path}/adminclientes`} component={AdminClientes} />
            <PrivateRoute path={`${match.path}/newtemplate`} component={NovoTemplate} />
            <PrivateRoute path={`${match.path}/allpostunblockeds`} component={AllPostsUnblocked} />
            <PrivateRoute path={`${match.path}/templateedit`} component={TemplateEdit} />
            <PrivateRoute path={`${match.path}/tutoriais`} component={Tutorials} />
            <PrivateRoute path={`${match.path}/configpagesblog`} component={ConfigPagesBlog} />
            <PrivateRoute path={`${match.path}/`} component={Home} />
            {/* <PrivateRoute path={`${match.path}/`} component={NotFound} /> */}

        </Switch>

    )
}

